import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  container: {
    alignItems: "center",
  },
  pad: {
    gap: spacing(2),
    width: "100%",
    maxWidth: spacing(84),
    alignSelf: "center",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing(2),
  },
  slot: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  systemRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing(2),
    paddingTop: spacing(3),
  },
}));

export default stylesheet;
